import useGrowthBookFeatureValue from 'components/GrowthBookProvider/useGrowthBookFeatureValue';
import { useWhitelabelFeatures } from 'hooks/whitelabel/useWhitelabelFeatures';

/**
 * Resolves whether the urgency discount UI is enabled for the current tenant.
 *
 * @returns {boolean} Whether the urgency discount UI is enabled.
 */
const useUrgencyDiscountUIEnabled = () => {
  const features = useWhitelabelFeatures() || {};
  const growthBookValue = useGrowthBookFeatureValue('show_discount_urgency');

  const enabledValue =
    growthBookValue === undefined ? features.SHOW_URGENCY_DISCOUNT_UI : growthBookValue;

  return enabledValue === true;
};

export default useUrgencyDiscountUIEnabled;
